import {apiWithToken} from '../../../systems/api';
import {API_URL} from '../../../systems/globalContant';

export default {
    attachPurchaser: (userId) => apiWithToken.put(API_URL.DEFAULT + `/users/${userId}/assign-teller`, {status: 1}, {loading: false}),
    detachPurchaser: (userId) => apiWithToken.put(API_URL.DEFAULT + `/users/${userId}/assign-teller`, {status: 0}, {loading: false}),
};
